import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {TollPoliciesContent} from "@/customComponents/globalComponents/policiesContent.jsx";

// Content lives in globalComponents/policiesContent.jsx (static copy).
export {TollPoliciesContent};

// backStep prefers `previousStep`: as an overlay level that is the step BELOW, so back
// POPS instead of pushing the policies list on top of the breakdown.
export function TollPolicies({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={previousStep || (storage.get(STORAGE_KEYS.PAYMENT_DETAILS_POLICIES) === true ? "paymentCards" : "policiesListing")} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <TollPoliciesContent/>
        </>
    );
}
export default TollPolicies;
